export const STORAGE_DATA = {
  TOKEN: 'token', // local
  IS_TIMEOUT: 'isTimeout', // local
  SHOPPINGCART_ID: 'shoppintcartId', // local
  SHOPPINGCART_CACHE_DATA: 'shoppingcartCacheData', // local
  LOGISTICS_CACHE_DATA: 'logisticsCacheData', // local
  SEARCH_HISTORY: 'searchHistory', // local
  FAST_CHECKOUT_CACHE_DATA: 'fastCheckoutCacheData', // session
  FIXED_PLAYER_CACHE_DATA: 'fixedPlayerCacheData', // session
  LOCATION_DATA: 'site_locationData', // session
  LINE_SHOP_REMINDER_READ: 'lineShopReminderRead', // session（僅在該頁籤開啟期間有效，關閉頁籤即清除）
  '2024_Chinese_New_Year_Lottery_Event': '2024ChineseNewYearLotteryEvent', // local
  PROFILE_GIFT_REMINDER_DISMISSED: 'profileGiftReminderDismissed', // local，「領取特別禮」Dialog 按過不再提醒
  CATEGORY_PREFERENCE_DISMISSED: 'categoryPreferenceDismissed', // session，首頁偏好分類 Dialog 按關閉後這次瀏覽不再跳
  MIGRATE_UPGRADE_ENTRY: 'migrateUpgradeEntry', // session，登入／忘記密碼被回升級錯誤碼時，把帳號與錯誤碼帶去 /migrate-upgrade（不放 query，避免帳號進網址）
  REGISTER_SOURCE: 'registerSource', // session，行銷連結 ?rs= 帶進來的來源，註冊送出時給後端 registerSource
  VISITOR_ID: 'visitorId', // local，訪客 uuid：最近看過、看了也看、推薦成效用
  THIRD_PARTY_REDIRECT: 'thirdPartyRedirect', // session，第三方登入發起前保存的站內導回路徑（E9 state 過期會落到預設頁，需自行還原）
  REMEMBERED_ACCOUNT: 'rememberedAccount', // local，登入頁勾「記住帳號」時保存的帳號（手機或 email，不含密碼）
}
